import { render, staticRenderFns } from "./DispatchSummaryAssetTypes.vue?vue&type=template&id=1298281b&scoped=true"
import script from "./DispatchSummaryAssetTypes.vue?vue&type=script&lang=js"
export * from "./DispatchSummaryAssetTypes.vue?vue&type=script&lang=js"
import style0 from "./DispatchSummaryAssetTypes.vue?vue&type=style&index=0&id=1298281b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298281b",
  null
  
)

export default component.exports